import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconCubeSvg } from './IconCubeSvg';

export const IconCube: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconCubeSvg} {...iconProps} />;
};
